// extracted by mini-css-extract-plugin
export default {"table-body":"TableBody_table-body__SAQIB","table-body-wrp":"TableBody_table-body-wrp__jSeUB","body":"TableBody_body__RsJJH"};